import "../../../styles/scroll.scss";

import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../util/config";

/**
 * Returnerar Icon node med icon kod inkluderad
 * 
 * @param {object} props
 * @returns {node}
 */
class Scroll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            topShadow: false,
            bottomShadow: false,
            leftShadow: false,
            rightShadow: false,

            lastCloseToBottomScrollTop: -1,
        };

        this.listenToScroll = this.listenToScroll.bind(this);
        this.setRef = this.setRef.bind(this);
    }

    componentDidMount() {
        this.listenToScroll();
    }

    UNSAFE_componentWillReceiveProps() {
        this.listenToScroll();
    }

    listenToScroll() {
        const {
            shadowX,
            shadowY,
            style,
            onCloseToBottom,
        } = this.props;
        const element = this.element;
        //test what needs a shadow
        const needTopShadow = element.offsetHeight < element.scrollHeight && shadowY && element.scrollTop > 0;
        const needBottomShadow = element.offsetHeight < element.scrollHeight && shadowY && element.scrollTop + element.offsetHeight !== element.scrollHeight;
        const needleftShadow = element.offsetWidth < element.scrollWidth && shadowX && element.scrollLeft > 0;
        const needRightShadow = element.offsetWidth < element.scrollWidth && shadowX && element.scrollLeft + element.offsetWidth !== element.scrollWidth;
        let lastCloseToBottomScrollTop = this.state.lastCloseToBottomScrollTop;
        //If we are close to the bottom, do the callback(onCloseToBottom)
        if (onCloseToBottom && style && element.scrollTop !== this.state.lastCloseToBottomScrollTop && element.scrollHeight - element.scrollTop < (parseInt(style.height) * 1.5)) {
            //position is used to protect against unecesary callbacks on UNSAFE_componentWillReceiveProps()
            lastCloseToBottomScrollTop = element.scrollTop;

            //<div onScroll={func}/> Will be called multiple times on a single scroll
            clearTimeout(this.onScroll);
            this.onScroll = setTimeout(function () {
                onCloseToBottom();
            }, 50);
        }
        //update only if anything changed
        if (this.state.topShadow !== needTopShadow || this.state.bottomShadow !== needBottomShadow || this.state.leftShadow !== needleftShadow || this.state.rightShadow !== needRightShadow ||
            this.state.lastCloseToBottomScrollTop !== lastCloseToBottomScrollTop) {
            this.setState({
                topShadow: needTopShadow,
                bottomShadow: needBottomShadow,
                leftShadow: needleftShadow,
                rightShadow: needRightShadow,
                lastCloseToBottomScrollTop: lastCloseToBottomScrollTop,
            });
        }

        if (this.props.onScroll) {
            this.props.onScroll(element.scrollLeft, element.scrollTop);
        }
    }

    setRef(element) {
        this.element = element;
    }

    render() {
        const {
            children,
            style,
            className,
            shadowStyle,
        } = this.props;
        const {
            topShadow,
            bottomShadow,
            leftShadow,
            rightShadow,
        } = this.state;

        return (
            <div className="scroll-wrapper" style={{ width: style ? style.width : undefined, height: style ? style.height : undefined }}>
                <div className="bottom-shadow" style={{ bottom: bottomShadow ? 0 : -parseInt(scssVariables.srollShadowSize), ...shadowStyle }} />
                <div className="top-shadow" style={{ top: topShadow ? 0 : -parseInt(scssVariables.srollShadowSize), ...shadowStyle }} />
                <div className="left-shadow" style={{ left: leftShadow ? 0 : -parseInt(scssVariables.srollShadowSize), ...shadowStyle }} />
                <div className="right-shadow" style={{ right: rightShadow ? 0 : -parseInt(scssVariables.srollShadowSize), ...shadowStyle }} />
                <div ref={this.setRef} onScroll={this.listenToScroll} className={`scroll-area ${className}`} style={{ ...style }}>
                    {children}
                </div>
            </div>
        );
    }

}

Scroll.propTypes = {
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
    className: PropTypes.string,
    //If shadow should be used when overflowing on X
    shadowX: PropTypes.bool,
    //If shadow should be used when overflowing on Y
    shadowY: PropTypes.bool,
    //Style used by shadows
    shadowStyle: PropTypes.object,
    //Called when half the height is left on the scroll
    onCloseToBottom: PropTypes.func,
    onScroll: PropTypes.func
};

Scroll.defaultProps = {
    shadowX: true,
    shadowY: true,
};

export default Scroll;